import React, { useState } from "react";
import phoneIcon from "../../../../assets/img/landing-page/phoneIcon.png";
import faceRecognitionIcon from "../../../../assets/img/landing-page/FaceRecognitionIcon.png";
import B2BDatabaseIcon from "../../../../assets/img/landing-page/B2BDatabaseIcon.png";
import phoneImage from "../../../../assets/img/landing-page/phoneImage.png";
import faceRecognitionImage from "../../../../assets/img/landing-page/FaceRecognitionImage.png";
import B2BDatabaseImage from "../../../../assets/img/landing-page/B2BDatabasesImage.png";
import Tabs from "../../../../components/tabs/tabs";
import "../../style.css";

const ReachYourIdeas = () => {
  const [activeTab, setActiveTab] = useState(0);

  const data = [
    {
      icon: phoneIcon,
      header: "Social Media platforms",
      desc: "Integrate Leadbus Data Effortlessly Into Your Marketing And Sales Strategies For A Lead Boost. Elevate Campaigns And Achieve Superior",
    },
    {
      icon: B2BDatabaseIcon,
      header: "B2B Databases",
      desc: "Integrate Leadbus Data Effortlessly Into Your Marketing And Sales Strategies For A Lead Boost. Elevate Campaigns And Achieve Superior.",
    },
    {
      icon: faceRecognitionIcon,
      header: "Face Recognition",
      desc: "Integrate Leadbus Data Effortlessly Into Your Marketing And Sales Strategies For A Lead Boost. Elevate Campaigns And Achieve Superior.",
    },
  ];

  const getActiveImage = (activeTab) => {
    if (activeTab === 0) {
      return phoneImage;
    } else if (activeTab === 1) {
      return B2BDatabaseImage;
    } else {
      return faceRecognitionImage;
    }
  };

  return (
    <div className="section home-features">
      <div className="container">
        <div className="upper aos-item aos-inint aos-animate">
          <h2 style={{ textAlign: "center" }}>
            Reach your ideal customers when <br /> they are most likely to buy
            with
          </h2>
        </div>
        <div
          className="row align-items-start reach-your-ideas"
          style={{ marginTop: "70px" }}
        >
          <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
            <div
              className="slider-tabs-outer-wrapper"
              style={{ position: "relative" }}
            >
              <div
                className="custom-divider"
                style={{
                  position: "absolute",
                  top: "0",
                  width: "1px",
                  height: "100%",
                  left: "46px",
                }}
              ></div>
              {data.map((item, i) => (
                <Tabs
                  isActive={activeTab === i}
                  onClick={() => setActiveTab(i)}
                  icon={item.icon}
                  heading={item.header}
                  desc={item.desc}
                />
              ))}
            </div>
          </div>
          <div
            className="col-lg-6 col-md-12 col-sm-12 col-xs-12 tabs-image-wrapper"
            style={{
              textAlign: "end",
            }}
          >
            <img
              style={{
                width: "600px",
                height: "auto",
              }}
              src={getActiveImage(activeTab)}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReachYourIdeas;
